import CommonModule, { QuestelServicesClient, RequestResult, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import PageList from '../models/Pagination/PageList';
import { User } from '@/models/Users/User';
import { LodgeConfigDTO } from '../models/LodgeConfigDTO';
import { getModule } from 'vuex-module-decorators';

export class UserService {
    private client: QuestelServicesClient;
    private commonState = getModule(CommonModule, store);

  constructor() {
    this.client = new QuestelServicesClient(store, "/api");
  }

  public async updateUserCache(): Promise<any> {
    return await this.client.postJson(`/v1/users/user-cache`, undefined);
  }

    public async getUserList(): Promise<User[]> {
        return await this.client.get<User[]>(`/v1/users/`);
    }

    public async getLodgeConfig(): Promise<LodgeConfigDTO> {
        return await this.client.get<LodgeConfigDTO>(`/v1/users/lodgeConfig`);
    }

    public async getSigningSofware(): Promise<any> {
        var request = new Request(`/api/v1/users/DownloadSignerSoftware`, {
            method: HttpMethodEnum.Get,
            headers: {
                "Authorization": `Bearer ${this.commonState.authToken}`,
            },
            keepalive: true
        });

        return fetch(request);
    }

    public async getDocumentation(): Promise<any> {
        var request = new Request(`/api/v1/users/DownloadDocumentation`, {
            method: HttpMethodEnum.Get,
            headers: {
                "Authorization": `Bearer ${this.commonState.authToken}`,
            },
            keepalive: true
        });

        return fetch(request);
    }
}